import React, { useEffect,useState } from "react";
import TriangularUp from "../assets/triangular-bg-demo-up.svg";
import TriangularDown from "../assets/triangular-bg-demo-down.svg";
import "./ProductTryout.css";
import MagicFeedback from "@magicfeedback/native";

function ProductTryout() {
  const [loading, setLoading] = useState(true);
  // Initialize and render the MagicFeedback SDK
  useEffect(() => {
    MagicFeedback.init();

    // Best in class
    const contactForm = MagicFeedback.form(
      "e95b7390-d587-11ee-905b-03387063b532",
      "28f10ab552b1f6f33ddfc90f73e0238a"
    );

    contactForm.generate("magicfeedback-contact-container", {
      addButton: true,
      sendButtonText: "Unlock Access",
      addSuccessScreen: true,
      questionFormat: "slim",
      onLoadedEvent: () =>
          setLoading(false),
      afterSubmitEvent: ({
        loading,
        progress,
        total,
        response, // Response of the server if everything is ok
        error, // Error of the server if something is wrong
      }) => {
        if (error) {
          // TODO: Show error message
        }

        //TODO: Show message of success
      },
    });

    //magicfeedback-success
  }, []);

  return (
    <div className="ProductTryout">
      <img
        src={TriangularUp}
        alt="background blue triangular"
        className="triangular-bg-trial"
      />
      <section className="product-tryout">
        <div className="product-tryout-container">
          <div className="product-tryout-content">
            <h2>Turn user feedback into insights with AI</h2>
            <p>
              Convert meeting notes, surveys, emails, support tickets and all
              other user feedback from multiple sources into actionable insights
              and trends.
            </p>
          </div>
          <div className="magicfeedback">
            {loading && <span className="loader"/>}
            <div id="magicfeedback-contact-container">
              {/** MagicFeedback SDK space */}
            </div>
          </div>
        </div>
      </section>
      <img
        src={TriangularDown}
        alt="background blue triangular"
        className="triangular-bg-trial"
      />
    </div>
  );
}

export default ProductTryout;
